import MenuOpenOutlinedIcon from '@mui/icons-material/MenuOpenOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import logoImg from '../img/logo.png'
import XIcon from '@mui/icons-material/X';
import FacebookIcon from '@mui/icons-material/Facebook';
import TelegramIcon from '@mui/icons-material/Telegram';
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import SavingsIcon from '@mui/icons-material/Savings';


function Sidebar() {
    return (
        <>
            <aside className="sidebar">
                <div className='sidebar-line'>
                    <div className="sidebar-logo d-flex align-items-center justify-content-between">
                        <a href="#sec" class="header-logo">
                            {/* <img src="assets/images/logo.svg" class="img-fluid light-logo" alt="logo" /> */}
                            <img src={logoImg} className='big-logo' height="50px" width="50px" alt='logo' />
                            <img src={logoImg} className='mini-logo' height="40px" width="40px" alt='logo' />
                        </a>
                        <div className="menu-bt-sidebar toggle-sidebar-btn">
                            <MenuOpenOutlinedIcon sx={{ color: "white" }} fontSize='large' />
                        </div>
                    </div>
                </div>
                <div className='sidebar-menu'>
                    <ul className="sidebar-menu-nav">
                        <li>
                            <a href="https://eat24mall.com/" target='_blank' rel="noreferrer">
                                <DashboardIcon sx={{ color: "#fff" }} className='me-2' />
                                <span>Shopping</span>
                            </a>
                        </li>
                        <li>
                            <a href="#sec" className='active'>
                                <EmojiEventsIcon sx={{ color: "#0fd505" }} className='me-2' />
                                <span>Staking</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://investcarboncredit.com/investcarboncredit">
                                <SwapHorizIcon sx={{ color: "#fff" }} className='me-2' />
                                <span>Invest Carbon Credits</span>
                            </a>
                        </li>
                        <li>
                            <a href=" https://pancakeswap.finance/swap?outputCurrency=0xaf07d3226970d223674f674410aD5d92f4f3aB95" target='_blank' rel="noreferrer">
                                <LayersOutlinedIcon sx={{ color: "#fff" }} className='me-2' />
                                <span>Swap</span>
                            </a>
                        </li>
                        <li>
                            <a href="#sec" target='_blank' rel="noreferrer">
                                <LocalGroceryStoreIcon sx={{ color: "#fff" }} className='me-2' />
                                <span>NFT</span>
                            </a>
                        </li>
                        <li>
                            <a href="#sec" target='_blank' rel="noreferrer">
                                <SavingsIcon sx={{ color: "#fff" }} className='me-2' />
                                <span>Stake EAT</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div className='sidebar-bottom'>
                    <h5 className='text-center text-white'>Join Us</h5>
                    <ul className='social-list'>
                        <li>
                            <a href="#sec" target='_blank' rel="noreferrer">
                                <TelegramIcon sx={{ fontSize: 24 }} />
                            </a>
                        </li>
                        <li>
                            <a href="#sec" target='_blank' rel="noreferrer">
                                <XIcon sx={{ fontSize: 20 }} />
                            </a>
                        </li>
                        <li>
                            <a href="#sec" target='_blank' rel="noreferrer">
                                <FacebookIcon sx={{ fontSize: 24 }} />
                            </a>
                        </li>
                    </ul>
                </div>
            </aside>
        </>
    )
}
export default Sidebar